module.exports = __webpack_public_path__ + "static/media/phiz.fb3f5f92.png";